import PeoplePreferencesView from "./PeoplePreferencesView"
export default PeoplePreferencesView
